const staticModule = {
  state: {
    businesses: [
      {
        header: "Increased Reach",
        icon: "increased_reach.svg",
        content:
          "sed viverra tellus in hac <br> habitasse platea dictumst <br> vestibulum rhoncus est"
      },
      {
        header: "Rist Free",
        icon: "risk_free.svg",
        content:
          "sed viverra tellus in hac <br> habitasse platea dictumst <br> vestibulum rhoncus est"
      },
      {
        header: "Easy Setup",
        icon: "easy_setup.svg",
        content:
          "sed viverra tellus in hac <br> habitasse platea dictumst <br> vestibulum rhoncus est"
      }
    ]
  },
  mutations: {}
};
export default staticModule;
